<div class="input-group" [ngClass]="{'append': placement === 'right', 'prepend': placement === 'left'}">
  <ng-content></ng-content>
  <div [ngClass]="{'input-group-append': placement === 'right', 'input-group-prepend': placement === 'left'}">
    <span class="input-group-text" aria-label="input icon">
      <ng-content select="[icon]"></ng-content>
    </span>
  </div>
</div>
